export const SERVICE = 'TOPPINGS'
